$(function () {
  // Bail out if we're not on the spam review page
  if ($('#filters_spam_type').length === 0) return;

  var $typeSelect = $('#filters_spam_type');
  var $confidenceInputs = $('.js-confidence-input');

  // Toggle confidence inputs based on spam type (disabled when type ≠ llm)
  $typeSelect.on('change', function () {
    var isLlm = $(this).val() === 'llm';
    $confidenceInputs.prop('disabled', !isLlm);
  }).trigger('change');

  // Auto-submit form on filter change (debounced to batch rapid changes)
  var submitTimer = null;
  $('#filters_spam_type, .datepicker, .js-confidence-input').on('change', function () {
    var $form = $(this).closest('form');
    clearTimeout(submitTimer);
    submitTimer = setTimeout(function () { $form.submit(); }, 300);
  });
});
